import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";  

const NotFound = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        background: "url('assets/Images/404.jpg') center/cover no-repeat", 
      }}
    >
      <div
        className="text-center p-5 rounded shadow"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)", 
          color: "#d4a643",
          maxWidth: "600px",
          width: "100%",
        }}
      >
        <h1 className="display-3 mb-4"><span className="fw-bold">404</span> - Page Not Found</h1>
        <p className="lead mb-4">
          Sorry, the page you are looking for does not exist.
        </p>
        <Link to="/">
          <button className="btn btn-war btn-lg">
            Go to Home
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
